var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.6666H16.9167V10.5C16.9167 8.88998 15.61 7.58331 14 7.58331C12.39 7.58331 11.0834 8.88998 11.0834 10.5V11.6666H10.5C9.85837 11.6666 9.33337 12.1916 9.33337 12.8333V18.6666C9.33337 19.3083 9.85837 19.8333 10.5 19.8333H17.5C18.1417 19.8333 18.6667 19.3083 18.6667 18.6666V12.8333C18.6667 12.1916 18.1417 11.6666 17.5 11.6666ZM14 16.9166C13.3584 16.9166 12.8334 16.3916 12.8334 15.75C12.8334 15.1083 13.3584 14.5833 14 14.5833C14.6417 14.5833 15.1667 15.1083 15.1667 15.75C15.1667 16.3916 14.6417 16.9166 14 16.9166ZM12.25 11.6666V10.5C12.25 9.53165 13.0317 8.74998 14 8.74998C14.9684 8.74998 15.75 9.53165 15.75 10.5V11.6666H12.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.faaa910bd74e873809bfd810af545d6c.svg";
export { ForwardRef as ReactComponent };